
/**
 * Helper function to handle service errors
 * @param error The error object
 * @param defaultMessage Default error message
 * @returns Error with appropriate message
 */
export const handleServiceError = (error: any, defaultMessage: string = "An error occurred"): Error => {
  console.error("Service error details:", error);
  
  // Handle Supabase errors
  if (error?.message) {
    return new Error(error.message);
  }
  
  // Handle unknown errors
  if (error) {
    console.error("Unexpected error type:", typeof error, error);
  }
  
  return new Error(defaultMessage);
};

/**
 * Higher-order function to wrap service methods with error handling
 * @param fn The function to wrap
 * @param defaultMessage Default error message
 * @returns Wrapped function with error handling
 */
export const withErrorHandling = <T, Args extends any[]>(
  fn: (...args: Args) => Promise<T>,
  defaultMessage: string = "An error occurred"
): ((...args: Args) => Promise<T>) => {
  return async (...args: Args): Promise<T> => {
    try {
      return await fn(...args);
    } catch (error) {
      console.error(`${defaultMessage}:`, error);
      throw handleServiceError(error, defaultMessage);
    }
  };
};
